import React from 'react';
import { SmartImage } from '../common/SmartImage';
import { IMAGES } from '../../lib/images';
/**
 * Auto-scrolling marquee of real customer photos (no AI images).
 * Duplicated once so the CSS marquee loops seamlessly.
 */
export function UserGallery() {
  const items = [...IMAGES.users, ...IMAGES.users];
  return <div className="relative overflow-hidden" data-id="element-50" data-mp="snuyf1r8138l">
      <div className="flex w-max animate-marquee gap-4" data-id="element-51" data-mp="smjun1xrzvhh">
        {items.map((src, i) => <div key={i} className="h-56 w-44 flex-shrink-0 overflow-hidden rounded-xl border border-[rgba(217,217,217,0.15)] sm:h-72 sm:w-56" data-id="element-52" data-mp="er7wekkevmvt" data-mpi={i}>
            <SmartImage src={src} alt="Customer using a RevoV vending machine" className="h-full w-full object-cover" data-id="element-53" data-mp="5q1i8i58io5q" />
          </div>)}
      </div>
      {/* Edge fades */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-navy to-transparent" data-id="element-54" data-mp="24430z36nkek9" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-navy to-transparent" data-id="element-55" data-mp="2cs43sf4tf8ws" />
    </div>;
}